import clsx from 'clsx';
import styles from './style.module.less';
import { Image, Button, TextLink } from '@bfe/moly';
import { useFm, useScreenType } from '@web3/base-hooks';
import { publicAssetsPath } from '@web3/base-utils';
import {
  // useCurrentWallet,
  // useUserInfo,
  useConnectWalletModal,
} from '@web3fe/infra';
import { useMemo } from 'react';
import { Tooltip } from '@bfe/moly';

export const SectionDailyCheckin = () => {
  const { isMobile } = useScreenType();
  const fm = useFm();
  const connectWallet = useConnectWalletModal();
  const checkInList = useMemo(
    () =>
      Array.from({ length: 6 }, (v, k) => ({
        point: 1,
        day: `D${k + 1}`,
      })).concat([{ point: 3, day: `D7` }]),
    []
  );
  return (
    <section className={clsx(styles['section-wrap'], 'flex mt-6')}>
      <div className={clsx('bg-card flex gap-4', styles['task-left'])}>
        <Image
          className={clsx(
            styles['task-icon'],
            isMobile ? 'w-12 h-12' : 'w-15 h-15'
          )}
          src={publicAssetsPath('/png/upcoming/task-daily-check.png')}
          alt="dexpro"
        />
        <div>
          <h3
            className={clsx(
              'flex items-center font-semibold',
              isMobile ? 'text-base' : 'text-2xl'
            )}
          >
            {fm('dailyCheckIn')}
          </h3>
          <Tooltip title={fm('completeTasksEarnPts')}>
            <p
              className={clsx(
                ' text-gray-t2 font-light line-clamp-2 mt-2 cursor-pointer',
                isMobile ? 'text-xs' : 'text-sm'
              )}
            >
              {fm('completeTasksEarnPts')}
            </p>
          </Tooltip>
        </div>
      </div>
      <div
        className={clsx(
          'bg-area flex items-center justify-between gap-6 flex-1',
          styles['task-right']
        )}
      >
        <div className="grid grid-cols-7 flex-1">
          {checkInList.map((item) => (
            <div key={item.day} className="">
              <div
                className={clsx(
                  styles['check-day'],
                  'text-lg font-semibold',
                  item.day === 'D7'
                    ? [styles['check-day-d7'], 'text-white']
                    : 'text-gray-t2'
                )}
              >
                <span>+</span>
                <span>{item.point}</span>
              </div>
              <p className={clsx('text-center text-gray-t3 text-xs mt-1')}>
                {item.day}
              </p>
            </div>
          ))}
        </div>
        <Button
          variant="secondary"
          className="text-lg w-60 h-14"
          onClick={() => connectWallet.show()}
        >
          {fm('dailySignIn')}
        </Button>
      </div>
    </section>
  );
};
